import React from 'react'
import Bill from './Bill'

function Status() {
  return (
    <div><Bill/></div>
  )
}

export default Status